import { render } from "./AgentAvgEarningsFourChart.vue?vue&type=template&id=47f39d30&ts=true"
import script from "./AgentAvgEarningsFourChart.vue?vue&type=script&lang=ts"
export * from "./AgentAvgEarningsFourChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__